
    import './styles.scoped.css';
    export default {
  "radio-button": "awsui_radio-button_feeqa_117rp_5",
  "selected": "awsui_selected_feeqa_117rp_9"
};
  